(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "idb-keyval", "lodash/set", "../constants", "throttle-debounce", "../events", "../request", "./inapp.schema", "./types", "./utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("idb-keyval"), require("lodash/set"), require("../constants"), require("throttle-debounce"), require("../events"), require("../request"), require("./inapp.schema"), require("./types"), require("./utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.idbKeyval, global.set, global.constants, global.throttleDebounce, global.events, global.request, global.inapp, global.types, global.utils);
    global.inapp = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _idbKeyval, _set2, _constants, _throttleDebounce, _events, _request, _inapp, _types, _utils) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.clearMessages = void 0;
  _exports.getInAppMessages = getInAppMessages;
  _set2 = _interopRequireDefault(_set2);
  _inapp = _interopRequireDefault(_inapp);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  let parsedMessages = [];
  let timer = null;
  let messageIndex = 0;
  let isPaused = false;

  const clearMessages = () => {
    parsedMessages = [];
    messageIndex = 0;
    isPaused = false;

    if (timer) {
      clearTimeout(timer);
    }
  };

  _exports.clearMessages = clearMessages;

  function getInAppMessages(payload, options) {
    clearMessages();

    const dupedPayload = _objectSpread({}, payload);
    /* delete SDK-defined payload props and email and userId */


    delete dupedPayload.userId;
    delete dupedPayload.email;
    delete dupedPayload.displayInterval;
    delete dupedPayload.onOpenScreenReaderMessage;
    delete dupedPayload.onOpenNodeToTakeFocus;
    delete dupedPayload.topOffset;
    delete dupedPayload.bottomOffset;
    delete dupedPayload.rightOffset;
    delete dupedPayload.animationDuration;
    delete dupedPayload.handleLinks;
    delete dupedPayload.closeButton;

    const requestInAppMessages = ({
      latestCachedMessageId
    }) => (0, _request.baseIterableRequest)({
      method: 'GET',

      /** @note parameter will be enabled once new endpoint is ready */
      // url: options?.useLocalCache ? CACHE_ENABLED_GETMESSAGES_PATH : GETMESSAGES_PATH,
      url: _constants.GETMESSAGES_PATH,
      validation: {
        params: _inapp.default
      },
      params: _objectSpread(_objectSpread({}, dupedPayload), {}, {
        platform: _constants.WEB_PLATFORM,
        SDKVersion: _constants.SDK_VERSION,
        latestCachedMessageId
      })
    });

    const requestMessages = async () => {
      /** @note caching implementation and associated parameter will be enabled once new endpoint is ready */
      // if (!options?.useLocalCache) return await requestInAppMessages({});

      /** @note always early return until then */
      return await requestInAppMessages({});

      try {
        const cachedMessages = await (0, _idbKeyval.entries)();
        /** determine most recent cached message */

        let latestCachedMessageId;
        let latestCreatedAtTimestamp = 0;
        cachedMessages.forEach(([cachedMessageId, cachedMessage]) => {
          if (cachedMessage.createdAt > latestCreatedAtTimestamp) {
            latestCachedMessageId = cachedMessageId;
            latestCreatedAtTimestamp = cachedMessage.createdAt;
          }
        });
        /**
         * call getMessages with latestCachedMessageId to get the message delta
         * (uncached messages have full detail, rest just have messageId)
         */

        const response = await requestInAppMessages({
          latestCachedMessageId
        });
        const {
          inAppMessages
        } = response.data;
        /** combine cached messages with NEW messages in delta response */

        const allMessages = [];
        const newMessages = [];
        inAppMessages === null || inAppMessages === void 0 ? void 0 : inAppMessages.forEach(inAppMessage => {
          /**
           * if message in response has no content property, then that means it is
           * older than the latest cached message and should be retrieved from the
           * cache using the messageId
           *
           * expecting messages with no content to look like the last 2 messages...
           * {
           *   inAppMessages: [
           *     { ...messageWithContentHasFullDetails01 },
           *     { ...messageWithContentHasFullDetails02 },
           *     { messageId: 'messageWithoutContentHasNoOtherProperties01' },
           *     { messageId: 'messageWithoutContentHasNoOtherProperties02' }
           *   ]
           * }
           */
          if (!inAppMessage.content) {
            const cachedMessage = cachedMessages.find(([messageId]) => inAppMessage.messageId === messageId);
            if (cachedMessage) allMessages.push(cachedMessage[1]);
          } else {
            allMessages.push(inAppMessage);
            if (inAppMessage.messageId) newMessages.push({
              messageId: inAppMessage.messageId,
              message: inAppMessage
            });
          }
        });
        /** delete messages not present in fetch from cache */

        const cachedMessagesToDelete = (0, _utils.getCachedMessagesToDelete)(cachedMessages, inAppMessages);

        try {
          await (0, _idbKeyval.delMany)(cachedMessagesToDelete);
        } catch (err) {
          var _err$response, _err$response$data;

          console.warn('Error deleting messages from the browser cache', (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.clientErrors) ?? err);
        }
        /** add new messages to the cache if they fit in the cache */


        await (0, _utils.addNewMessagesToCache)(newMessages);
        /** return combined response */

        return _objectSpread(_objectSpread({}, response), {}, {
          data: {
            inAppMessages: allMessages
          }
        });
      } catch (err) {
        var _err$response2, _err$response2$data;

        console.warn('Error requesting in-app messages', (err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.clientErrors) ?? err);
      }

      return await requestInAppMessages({});
    };

    if (options !== null && options !== void 0 && options.display) {
      (0, _utils.addStyleSheet)(document, (0, _constants.ANIMATION_STYLESHEET)(payload.animationDuration));

      const paintMessageToDOM = () => {
        var _parsedMessages;

        if ((_parsedMessages = parsedMessages) !== null && _parsedMessages !== void 0 && _parsedMessages[messageIndex]) {
          var _activeMessage$conten, _activeMessage$conten2, _activeMessage$conten3, _activeMessage$conten4, _activeMessage$conten7, _activeMessage$conten8, _activeMessage$conten9, _activeMessage$conten10, _activeMessage$conten11, _activeMessage$conten12;

          const activeMessage = parsedMessages[messageIndex];
          const shouldAnimate = activeMessage === null || activeMessage === void 0 ? void 0 : (_activeMessage$conten = activeMessage.content) === null || _activeMessage$conten === void 0 ? void 0 : (_activeMessage$conten2 = _activeMessage$conten.inAppDisplaySettings) === null || _activeMessage$conten2 === void 0 ? void 0 : _activeMessage$conten2.shouldAnimate;
          const position = (activeMessage === null || activeMessage === void 0 ? void 0 : (_activeMessage$conten3 = activeMessage.content) === null || _activeMessage$conten3 === void 0 ? void 0 : (_activeMessage$conten4 = _activeMessage$conten3.webInAppDisplaySettings) === null || _activeMessage$conten4 === void 0 ? void 0 : _activeMessage$conten4.position) || 'Center';

          const dismissMessage = (activeIframe, url) => {
            var _activeMessage$conten5, _activeMessage$conten6;

            if (activeMessage !== null && activeMessage !== void 0 && (_activeMessage$conten5 = activeMessage.content) !== null && _activeMessage$conten5 !== void 0 && (_activeMessage$conten6 = _activeMessage$conten5.inAppDisplaySettings) !== null && _activeMessage$conten6 !== void 0 && _activeMessage$conten6.shouldAnimate) {
              activeIframe.className = position === 'Center' || position === 'Full' ? 'fade-out' : 'slide-out';
            }

            const trackPayload = {
              messageId: activeMessage.messageId,
              deviceInfo: {
                appPackageName: dupedPayload.packageName
              }
            };
            /* close the message and start a timer to show the next one */

            (0, _events.trackInAppClose)(url ? _objectSpread(_objectSpread({}, trackPayload), {}, {
              clickedUrl: url
            }) : trackPayload).catch(e => e);

            if (shouldAnimate) {
              const animationTimer = global.setTimeout(() => {
                activeIframe.remove();
                clearTimeout(animationTimer);
              }, _constants.ANIMATION_DURATION);
            } else {
              activeIframe.remove();
            }

            const timeToNextMessage = shouldAnimate ? (payload.displayInterval || _constants.DISPLAY_INTERVAL_DEFAULT) + _constants.ANIMATION_DURATION : payload.displayInterval || _constants.DISPLAY_INTERVAL_DEFAULT;
            messageIndex += 1;
            timer = global.setTimeout(() => {
              clearTimeout(timer);
              paintMessageToDOM();
            }, timeToNextMessage);
          };

          const overlay = (0, _utils.paintOverlay)(activeMessage === null || activeMessage === void 0 ? void 0 : (_activeMessage$conten7 = activeMessage.content) === null || _activeMessage$conten7 === void 0 ? void 0 : (_activeMessage$conten8 = _activeMessage$conten7.inAppDisplaySettings) === null || _activeMessage$conten8 === void 0 ? void 0 : (_activeMessage$conten9 = _activeMessage$conten8.bgColor) === null || _activeMessage$conten9 === void 0 ? void 0 : _activeMessage$conten9.hex, activeMessage === null || activeMessage === void 0 ? void 0 : (_activeMessage$conten10 = activeMessage.content) === null || _activeMessage$conten10 === void 0 ? void 0 : (_activeMessage$conten11 = _activeMessage$conten10.inAppDisplaySettings) === null || _activeMessage$conten11 === void 0 ? void 0 : (_activeMessage$conten12 = _activeMessage$conten11.bgColor) === null || _activeMessage$conten12 === void 0 ? void 0 : _activeMessage$conten12.alpha, shouldAnimate);
          /* add the message's html to an iframe and paint it to the DOM */

          return (0, _utils.paintIFrame)(activeMessage.content.html, position, shouldAnimate, payload.onOpenScreenReaderMessage || 'in-app iframe message opened', payload.topOffset, payload.bottomOffset, payload.rightOffset).then(activeIframe => {
            var _activeIframe$content10, _payload$closeButton, _activeIframe$content14, _activeIframe$content17;

            const throttledResize = position !== 'Full' ? (0, _throttleDebounce.throttle)(750, () => {
              var _activeIframe$content, _activeIframe$content2, _activeIframe$content3;

              activeIframe.style.height = (((_activeIframe$content = activeIframe.contentWindow) === null || _activeIframe$content === void 0 ? void 0 : (_activeIframe$content2 = _activeIframe$content.document) === null || _activeIframe$content2 === void 0 ? void 0 : (_activeIframe$content3 = _activeIframe$content2.body) === null || _activeIframe$content3 === void 0 ? void 0 : _activeIframe$content3.scrollHeight) || 0) + 'px';
            }) : () => null;
            global.addEventListener('resize', throttledResize);

            try {
              var _activeIframe$content4, _activeIframe$content5;

              const elementToFocus = (_activeIframe$content4 = activeIframe.contentWindow) === null || _activeIframe$content4 === void 0 ? void 0 : (_activeIframe$content5 = _activeIframe$content4.document.body) === null || _activeIframe$content5 === void 0 ? void 0 : _activeIframe$content5.querySelector(payload.onOpenNodeToTakeFocus || '');
              /* try to focus on the query selector the customer provided  */

              elementToFocus.focus();
            } catch (e) {
              var _activeIframe$content6, _activeIframe$content7;

              /* otherwise, find the first focusable element and focus on that */
              const firstFocusableElement = (_activeIframe$content6 = activeIframe.contentWindow) === null || _activeIframe$content6 === void 0 ? void 0 : (_activeIframe$content7 = _activeIframe$content6.document.body) === null || _activeIframe$content7 === void 0 ? void 0 : _activeIframe$content7.querySelector('button, a:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"])');

              if (firstFocusableElement) {
                firstFocusableElement.focus();
              }
            }

            const handleEscKeypress = (event, documentEventHandler, iframeEventHandler) => {
              if (event.key === 'Escape') {
                var _activeIframe$content8;

                dismissMessage(activeIframe);
                overlay.remove();
                document.removeEventListener('keydown', documentEventHandler);

                if (activeIframe !== null && activeIframe !== void 0 && (_activeIframe$content8 = activeIframe.contentWindow) !== null && _activeIframe$content8 !== void 0 && _activeIframe$content8.document && !!iframeEventHandler) {
                  var _activeIframe$content9;

                  (_activeIframe$content9 = activeIframe.contentWindow) === null || _activeIframe$content9 === void 0 ? void 0 : _activeIframe$content9.document.removeEventListener('keydown', iframeEventHandler);
                }

                global.removeEventListener('resize', throttledResize);
              }
            };
            /*
              handleDocumentEscPress and handleIFrameEscPress both are separate
              keydown handlers to dismiss the message when the _esc_ key is pressed.
               The reason these are abstracted into their own methods is because the method
              for adding the event handler also removes itself in its own callback. BUT since
              we have 2 event listeners (one for the document, and one for the iframe), the method
              to add the listener needs to know about both of these _addEventListener_ abstracted
              callbacks so the code can properly remove the same listener that was added.
               In other words, it solves for the issue where you're adding an event listener as a lambda
              like so and and you get a unique event listener each time:
               document.addEventListener('keydown', () => // do stuff)
               this example code adds a new event listener each time and never gets cleaned up 
              because there's no reference that to "() => // do stuff" that can be re-used in the
              _removeEventListener_ call.
            */


            const handleDocumentEscPress = event => handleEscKeypress(event, handleDocumentEscPress);

            const handleIFrameEscPress = event => handleEscKeypress(event, handleDocumentEscPress, handleIFrameEscPress);

            document.addEventListener('keydown', handleDocumentEscPress);

            if (activeIframe !== null && activeIframe !== void 0 && (_activeIframe$content10 = activeIframe.contentWindow) !== null && _activeIframe$content10 !== void 0 && _activeIframe$content10.document) {
              var _activeIframe$content11;

              (_activeIframe$content11 = activeIframe.contentWindow) === null || _activeIframe$content11 === void 0 ? void 0 : _activeIframe$content11.document.addEventListener('keydown', handleIFrameEscPress);
            }

            const ua = navigator.userAgent;
            const isSafari = !!ua.match(/safari/i) && !ua.match(/chrome|chromium|crios/i);
            /**
             * We allow users to dismiss messages by clicking outside of the
             * message not only when isRequiredToDismissMessage is not true
             * but also when browser is detected to be Safari, regardless of
             * whether isRequiredToDismissMessage is true. Safari blocks
             * all bound event handlers and so we cannot execute Javascript
             * to listen for click events. As such, we should not prevent users
             * from being able to dismiss the message by clicking outside of it.
             */

            if (!((_payload$closeButton = payload.closeButton) !== null && _payload$closeButton !== void 0 && _payload$closeButton.isRequiredToDismissMessage) || isSafari) {
              overlay.addEventListener('click', () => {
                var _activeIframe$content12;

                dismissMessage(activeIframe);
                overlay.remove();
                document.removeEventListener('keydown', handleDocumentEscPress);

                if (activeIframe !== null && activeIframe !== void 0 && (_activeIframe$content12 = activeIframe.contentWindow) !== null && _activeIframe$content12 !== void 0 && _activeIframe$content12.document) {
                  var _activeIframe$content13;

                  (_activeIframe$content13 = activeIframe.contentWindow) === null || _activeIframe$content13 === void 0 ? void 0 : _activeIframe$content13.document.removeEventListener('keydown', handleIFrameEscPress);
                }

                global.removeEventListener('resize', throttledResize);
              });
            }
            /*
              create an absolutely positioned button that lies underneath the
              in-app message and takes up full width and height
               The reason for this is if the customer made their in-app take less width
              than the iframe surrounding it, they should still be able to click outside
              their in-app, but within the bounds of the iframe to dismiss it.
               The overlay doesn't handle this because the overlay only surrounds the iframe,
              not the in-app message. So imagine an in-app looking like this:
            */


            if ((_activeIframe$content14 = activeIframe.contentWindow) !== null && _activeIframe$content14 !== void 0 && _activeIframe$content14.document) {
              const absoluteDismissButton = activeIframe.contentWindow.document.createElement('button');
              absoluteDismissButton.style.cssText = `
                background: none;
                color: inherit;
                border: none;
                padding: 0;
                font: inherit;
                cursor: unset;
                outline: inherit;
                height: 100vh;
                width: 100vw;
                position: fixed;
                top: 0;
                left: 0;
                z-index: -1;
              `;
              /* 
                don't let the user tab to this button. 
                It's not necessarily for blind folks to tab over 
              */

              absoluteDismissButton.tabIndex = -1;

              const triggerClose = () => {
                var _activeIframe$content15;

                dismissMessage(activeIframe);
                overlay.remove();
                document.removeEventListener('keydown', handleDocumentEscPress);

                if (activeIframe !== null && activeIframe !== void 0 && (_activeIframe$content15 = activeIframe.contentWindow) !== null && _activeIframe$content15 !== void 0 && _activeIframe$content15.document) {
                  var _activeIframe$content16;

                  (_activeIframe$content16 = activeIframe.contentWindow) === null || _activeIframe$content16 === void 0 ? void 0 : _activeIframe$content16.document.removeEventListener('keydown', handleIFrameEscPress);
                }

                global.removeEventListener('resize', throttledResize);
              };

              absoluteDismissButton.addEventListener('click', triggerClose);
              activeIframe.contentWindow.document.body.appendChild(absoluteDismissButton);
              /**
               * Here we paint an optional close button if the user provided configuration
               * values. This button is just a quality-of-life feature so that the customer will
               * have an easy way to close the modal outside of the other methods.
               *
               * Do not show close button if browser is detected to be Safari because the close
               * button will not be able to dismiss the message (Safari blocks JS from running
               * on bound event handlers)
               */

              if (payload.closeButton && !isSafari) {
                var _payload$closeButton2, _payload$closeButton3, _payload$closeButton4, _payload$closeButton5;

                const newButton = (0, _utils.generateCloseButton)(document, (_payload$closeButton2 = payload.closeButton) === null || _payload$closeButton2 === void 0 ? void 0 : _payload$closeButton2.position, (_payload$closeButton3 = payload.closeButton) === null || _payload$closeButton3 === void 0 ? void 0 : _payload$closeButton3.color, (_payload$closeButton4 = payload.closeButton) === null || _payload$closeButton4 === void 0 ? void 0 : _payload$closeButton4.size, (_payload$closeButton5 = payload.closeButton) === null || _payload$closeButton5 === void 0 ? void 0 : _payload$closeButton5.iconPath, payload.closeButton.topOffset, payload.closeButton.sideOffset);
                newButton.addEventListener('click', triggerClose);
                activeIframe.contentWindow.document.body.appendChild(newButton);
              }
            }
            /* 
              track in-app consumes only when _saveToInbox_ 
              is falsy or undefined and always track in-app opens
               Also swallow any 400+ response errors. We don't care about them.
            */


            if (_constants.ENABLE_INAPP_CONSUME || _constants.IS_PRODUCTION) {
              const trackPayload = {
                messageId: activeMessage.messageId,
                deviceInfo: {
                  appPackageName: payload.packageName
                }
              };
              const trackRequests = [(0, _events.trackInAppOpen)(trackPayload), ...(!activeMessage.saveToInbox ? [(0, _events.trackInAppConsume)(trackPayload)] : [])];
              Promise.all(trackRequests).catch(e => e);
            }
            /* now we'll add click tracking to _all_ anchor tags */


            const links = ((_activeIframe$content17 = activeIframe.contentDocument) === null || _activeIframe$content17 === void 0 ? void 0 : _activeIframe$content17.querySelectorAll('a')) || [];
            links.forEach(link => {
              const clickedUrl = link.getAttribute('href') || '';
              const openInNewTab = link.getAttribute('target') === '_blank';
              const isIterableKeywordLink = !!clickedUrl.match(/iterable:\/\/|action:\/\//gim);
              const isDismissNode = !!clickedUrl.match(/iterable:\/\/dismiss/gim);
              const isActionLink = !!clickedUrl.match(/action:\/\//gim);
              const clickedHostname = (0, _utils.getHostnameFromUrl)(clickedUrl);
              /* !clickedHostname means the link was relative with no hostname */

              const isInternalLink = clickedHostname === global.location.host || !clickedHostname;
              const {
                handleLinks
              } = payload;
              /* 
                If the _handleLinks_ option is set, we need to open links 
                according to that enum and override their target attributes.
                 1. If _open-all-same-tab_, then open every link in the same tab
                2. If _open-all-new-tab_, then open every link in a new tab
                3. If _external-new-tab_, then open internal links in same tab, otherwise new tab.
                 This was a fix to account for the fact that Bee editor templates force
                target="_blank" on all links, so we gave this option as an escape hatch for that.
              */

              const manageHandleLinks = (sameTabAction, newTabAction) => {
                if (typeof handleLinks === 'string') {
                  if (handleLinks === 'open-all-same-tab' || isInternalLink && handleLinks === 'external-new-tab') {
                    sameTabAction();
                  } else {
                    newTabAction();
                  }
                }
              };

              if (isDismissNode || isActionLink) {
                /* 
                  give the close anchor tag properties that make it 
                  behave more like a button with a logical aria label
                */
                (0, _utils.addButtonAttrsToAnchorTag)(link, 'close modal');
              }
              /**
                Safari blocks all bound event handlers (including our click event handlers)
                in iframes, so links will not work in Safari unless we circumvent the
                restriction by appending target to each link tag.
                 @note Because click event handlers cannot be attached to iframe links in
                Safari, we cannot track in-app click metrics for Safari in Iterable analytics.
              */


              if (isSafari) {
                if (!isIterableKeywordLink) {
                  manageHandleLinks(() => link.setAttribute('target', '_top'), () => {
                    link.setAttribute('target', '_blank');
                    link.setAttribute('rel', 'noopener noreferrer');
                  });
                  const targetAttr = link.getAttribute('target');

                  if (!handleLinks && (targetAttr === null || targetAttr === '_self')) {
                    link.setAttribute('target', '_top');
                  }
                }
              } else {
                link.addEventListener('click', event => {
                  /* 
                    remove default linking behavior because we're in an iframe 
                    so we need to link the user programatically
                  */
                  event.preventDefault();

                  if (clickedUrl) {
                    const isOpeningLinkInSameTab = !handleLinks && !openInNewTab || handleLinks === 'open-all-same-tab' || isInternalLink && handleLinks === 'external-new-tab';
                    (0, _events.trackInAppClick)({
                      clickedUrl,
                      messageId: activeMessage === null || activeMessage === void 0 ? void 0 : activeMessage.messageId,
                      deviceInfo: {
                        appPackageName: dupedPayload.packageName
                      }
                    },
                    /* 
                      only call with the fetch API if we're linking in the 
                      same tab and it's not a reserved keyword link.
                    */
                    isOpeningLinkInSameTab && !isIterableKeywordLink
                    /* swallow the network error */
                    ).catch(e => e);

                    if (isDismissNode || isActionLink) {
                      var _activeIframe$content18;

                      dismissMessage(activeIframe, clickedUrl);
                      overlay.remove();
                      document.removeEventListener('keydown', handleDocumentEscPress);

                      if (activeIframe !== null && activeIframe !== void 0 && (_activeIframe$content18 = activeIframe.contentWindow) !== null && _activeIframe$content18 !== void 0 && _activeIframe$content18.document) {
                        var _activeIframe$content19;

                        (_activeIframe$content19 = activeIframe.contentWindow) === null || _activeIframe$content19 === void 0 ? void 0 : _activeIframe$content19.document.removeEventListener('keydown', handleIFrameEscPress);
                      }

                      global.removeEventListener('resize', throttledResize);
                    }

                    if (isActionLink) {
                      var _ref, _RegExp;

                      const filteredMatch = (_ref = ((_RegExp = new RegExp(/^.*action:\/\/(.*)$/, 'gmi')) === null || _RegExp === void 0 ? void 0 : _RegExp.exec(clickedUrl)) || []) === null || _ref === void 0 ? void 0 : _ref[1];
                      /* 
                        just post the message to the window when clicking 
                        action:// links and early return
                      */

                      return global.postMessage({
                        type: 'iterable-action-link',
                        data: filteredMatch
                      }, '*');
                    }
                    /*
                      finally (since we're in an iframe), programatically click the link
                      and send the user to where they need to go, only if it's not one
                      of the reserved iterable keyword links
                    */


                    if (!isIterableKeywordLink) {
                      manageHandleLinks(() => global.location.assign(clickedUrl), () => {
                        global.open(clickedUrl, '_blank', 'noopener,noreferrer');
                      });

                      if (!handleLinks) {
                        if (openInNewTab)
                          /**
                            Using target="_blank" without rel="noreferrer" and rel="noopener"
                            makes the website vulnerable to window.opener API exploitation attacks
                               @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#security_and_privacy
                          */
                          global.open(clickedUrl, '_blank', 'noopener,noreferrer');else global.location.assign(clickedUrl);
                      }
                    }
                  }
                });
              }
            });
            return activeIframe;
          });
        }

        return Promise.resolve('');
      };

      const isDeferred = options.display === _types.DISPLAY_OPTIONS.deferred;
      const triggerDisplayFn = isDeferred ? {
        triggerDisplayMessages: messages => {
          parsedMessages = (0, _utils.filterHiddenInAppMessages)(messages);
          return paintMessageToDOM();
        }
      } : {};
      return _objectSpread({
        request: () => requestMessages().then(response => {
          (0, _utils.trackMessagesDelivered)(response.data.inAppMessages || [], dupedPayload.packageName);
          return response;
        }).then(response => {
          if (isDeferred)
            /*
              if the user passed "deferred" for the second argument to _getMessages_
              then they're going to choose to display the in-app messages when they want
              with the returned, _triggerDisplayMessages_ function. So early return here
              with no filtering or sorting.
            */
            return response;
          /* otherwise, they're choosing to show the messages automatically */

          /* 
            if the user passed the flag to automatically paint the in-app messages
            to the DOM, start a timer and show each in-app message upon close + timer countdown
            
            However there are 3 conditions in which to not show a message:
            
            1. _read_ key is truthy
            2. _trigger.type_ key is "never" (deliver silently is checked)
            3. HTML body is blank
             so first filter out unwanted messages and sort them
          */

          clearMessages();
          parsedMessages = (0, _utils.sortInAppMessages)((0, _utils.filterHiddenInAppMessages)(response.data.inAppMessages));
          return paintMessageToDOM().then(() => {
            return _objectSpread(_objectSpread({}, response), {}, {
              data: {
                inAppMessages: parsedMessages
              }
            });
          });
        }),
        pauseMessageStream: () => {
          if (timer) {
            isPaused = true;
            clearTimeout(timer);
          }
        },
        resumeMessageStream: () => {
          if (isPaused) {
            isPaused = false;
            return paintMessageToDOM();
          }
        }
      }, triggerDisplayFn);
    }
    /* 
      user doesn't want us to paint messages automatically.
      just return the promise like normal
    */


    return requestMessages().then(response => {
      const messages = response.data.inAppMessages;
      (0, _utils.trackMessagesDelivered)(messages || [], dupedPayload.packageName);
      const withIframes = messages === null || messages === void 0 ? void 0 : messages.map(message => {
        var _message$content;

        const html = (_message$content = message.content) === null || _message$content === void 0 ? void 0 : _message$content.html;
        return html ? (0, _set2.default)(message, 'content.html', (0, _utils.wrapWithIFrame)(html)) : message;
      });
      return _objectSpread(_objectSpread({}, response), {}, {
        data: _objectSpread(_objectSpread({}, response.data), {}, {
          inAppMessages: withIframes
        })
      });
    });
  }
});